import { withInstall } from '../../utils/install';
import Breadcrumb from './index.vue';

export const IvueBreadcrumb = withInstall(Breadcrumb);
export default IvueBreadcrumb;

export * from './index.vue';
